(function () {
  var PRODUCT_WHATSAPP_EVENT = 'product_whatsapp_click';
  var QA_PARAMETER_NAMES = ['qa_mode', 'qa_run_id', 'qa_scenario'];
  var QA_RUN_PATTERN = /^[A-Za-z0-9_-]{6,64}$/;
  var QA_SCENARIO_PATTERN = /^[a-z0-9_-]{3,64}$/;

  function normalizeLocale(value) {
    var locale = String(value || '').toLowerCase().split('-')[0];
    return locale === 'en' ? 'en' : 'he';
  }

  function deviceType() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767px)').matches
      ? 'mobile'
      : 'desktop';
  }

  function renderedLocale() {
    return normalizeLocale(document.documentElement && document.documentElement.lang);
  }

  function renderedPageType() {
    return String(
      (document.documentElement && document.documentElement.dataset && document.documentElement.dataset.pageType) ||
        'other'
    );
  }

  function readQaContext() {
    var url = new URL(window.location.href);
    var qaRunId = url.searchParams.get('qa_run_id');
    var qaScenario = url.searchParams.get('qa_scenario');
    var requested = QA_PARAMETER_NAMES.some(function (parameterName) {
      return url.searchParams.has(parameterName);
    });
    var enabled =
      url.searchParams.get('qa_mode') === '1' &&
      QA_RUN_PATTERN.test(qaRunId || '') &&
      QA_SCENARIO_PATTERN.test(qaScenario || '');
    var context = { qa_mode: enabled ? 1 : 0 };

    if (enabled) {
      context.qa_run_id = qaRunId;
      context.qa_scenario = qaScenario;
    }

    if (requested) {
      QA_PARAMETER_NAMES.forEach(function (parameterName) {
        url.searchParams.delete(parameterName);
      });
      window.history.replaceState(
        window.history.state,
        '',
        url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash
      );
    }

    return context;
  }

  var qaContext = readQaContext();
  var globalEventContext = Object.assign(
    {
      storefront_locale: renderedLocale()
    },
    qaContext
  );

  if (typeof window.gtag === 'function') {
    window.gtag('set', globalEventContext);
  }

  function ctaLocation(link) {
    if (link.dataset && link.dataset.ctaLocation) return link.dataset.ctaLocation;
    if (typeof link.closest === 'function') {
      if (link.closest('header')) return 'header';
      if (link.closest('footer')) return 'footer';
      if (link.closest('main')) return 'main_content';
    }
    return 'page_content';
  }

  function basePayload(link, ctaType) {
    return Object.assign(
      {
        storefront_locale: normalizeLocale(
          (link.dataset && link.dataset.storefrontLocale) ||
            (document.documentElement && document.documentElement.lang)
        ),
        qa_mode: qaContext.qa_mode,
        device_type: deviceType(),
        page_path: window.location.pathname,
        page_type:
          (link.dataset && link.dataset.pageType) || renderedPageType(),
        cta_type: ctaType,
        cta_location: ctaLocation(link),
        transport_type: 'beacon'
      },
      qaContext.qa_mode === 1
        ? { qa_run_id: qaContext.qa_run_id, qa_scenario: qaContext.qa_scenario }
        : {}
    );
  }

  function sendGaEvent(eventName, link, ctaType) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, basePayload(link, ctaType));
  }

  function productWhatsAppPayload(link) {
    var payload = Object.assign(basePayload(link, 'product_whatsapp'), {
      product_id: link.dataset.productId,
      variant_id: link.dataset.variantId,
      product_handle: link.dataset.productHandle,
      destination: 'whatsapp',
      contact_channel: 'product_whatsapp'
    });

    if (link.dataset.variantSku) payload.variant_sku = link.dataset.variantSku;
    return payload;
  }

  function registeredShopifyMetaPixelId() {
    if (typeof window.fbq !== 'function' || typeof window.fbq.getState !== 'function') return '';

    try {
      var state = window.fbq.getState();
      var pixels = state && Array.isArray(state.pixels) ? state.pixels : [];

      for (var index = 0; index < pixels.length; index += 1) {
        if (pixels[index].agent === 'shopify_web_pixel' && pixels[index].id) {
          return String(pixels[index].id);
        }
      }

      return pixels.length === 1 && pixels[0].id ? String(pixels[0].id) : '';
    } catch (error) {
      return '';
    }
  }

  function sendProductWhatsAppEvent(link) {
    var payload = productWhatsAppPayload(link);

    if (typeof window.gtag === 'function') {
      window.gtag('event', PRODUCT_WHATSAPP_EVENT, payload);
    }

    if (typeof window.fbq === 'function') {
      var metaPixelId = registeredShopifyMetaPixelId();
      if (metaPixelId) {
        window.fbq('trackSingleCustom', metaPixelId, PRODUCT_WHATSAPP_EVENT, payload);
      } else {
        window.fbq('trackCustom', PRODUCT_WHATSAPP_EVENT, payload);
      }
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.href || '';
    var isWhatsAppLink = /wa\.me|whatsapp/i.test(href);

    if (isWhatsAppLink && link.dataset.eventName === PRODUCT_WHATSAPP_EVENT) {
      sendProductWhatsAppEvent(link);
      return;
    }

    if (href.indexOf('tel:') === 0) sendGaEvent('phone_click', link, 'phone');
    else if (isWhatsAppLink) sendGaEvent('whatsapp_click', link, 'generic_whatsapp');
    else if (href.indexOf('/pages/appointment') !== -1) sendGaEvent('appointment_click', link, 'appointment');
    else if (href.indexOf('/pages/contact') !== -1) sendGaEvent('contact_click', link, 'contact');
    else if (/google\.[^/]+\/maps|maps\.app\.goo\.gl/i.test(href)) sendGaEvent('maps_click', link, 'maps');
  });
})();
